import { Comision, EstadoInsaculacion, Evaluador, EvaluadorResumen } from '@conacyt/insaculacion-client';
import { TipoComision } from '@/shared/model/enumerations/tipo-comision.model';
import { ISolicitudRevision } from '@/shared/model/solicitud-revision.model';
import { IRevision, Revision } from '@/shared/model/revision.model';
import { ISolicitud } from '@/shared/model/solicitud.model';
import { Autoridad } from '@/shared/model/autoridad.model';

export interface ISolucion {
  id?: string;
  nombre?: string;
}

export class Solucion implements ISolucion {
  constructor(public id?: string, public nombre?: string) {}
}

export interface IMenuSolucion {
  text?: string;
  value?: Solucion;
}

export class MenuSolucion implements IMenuSolucion {
  constructor(public text?: string, public value?: Solucion) {}
}

export interface ISolucionEvaluador {
  solucion?: Solucion;
  evaluador?: Evaluador;
  estadoInsaculacion?: EstadoInsaculacion;
}
export class SolucionEvaluador implements ISolucionEvaluador {
  constructor(public solucion?: Solucion, public evaluador?: Evaluador, public estadoInsaculacion?: EstadoInsaculacion) {}
}

export interface IMenuSolucionEvaluador {
  text?: string;
  value?: SolucionEvaluador;
  disabled?: boolean;
}

export class MenuSolucionEvaluador implements IMenuSolucionEvaluador {
  constructor(public text?: string, public value?: SolucionEvaluador, public disabled?: boolean) {}
}

export interface ISolucionTipoComision {
  solucion?: Solucion;
  tipoComision?: TipoComision;
}
export class SolucionTipoComision implements ISolucionTipoComision {
  constructor(public solucion?: Solucion, public tipoComision?: TipoComision) {}
}

export interface IMenuSolucionTipoComision {
  text?: string;
  value?: SolucionTipoComision;
}

export class MenuSolucionTipoComision implements IMenuSolucionTipoComision {
  constructor(public text?: string, public value?: SolucionTipoComision) {}
}

export interface IMenuAutoridad {
  text?: string;
  value?: Autoridad;
}

export class MenuAutoridad implements IMenuAutoridad {
  constructor(public text?: string, public value?: Autoridad) {}
}

export interface ISolicitudRevisionTable extends ISolicitudRevision {
  /**
   * Aplica estilo a la fila de la tabla de acuerdo al estado de revisión
   */
  _rowVariant?: string;
  tieneEvaluacionCreada?: boolean;
}

/**
 * Tabla de evaluación plenaria
 */
export interface ISolicitudTablaPlenaria extends ISolicitud {
  revisiones?: Array<IRevision>;
  seleccionada?: boolean;
  tieneEvaluacionPlenaria?: boolean;
  evaluacionesIndividualesCoinciden?: boolean;
  cumpleEvaluacionesIndividuales?: boolean;
  cumplePresidenteComision?: boolean;
  estadoRevisionPlenaria?: string;
  _rowVariant?: string;
}

export interface IMenuComision {
  text?: string;
  value?: Comision;
}

export class MenuComision implements IMenuComision {
  constructor(public text?: string, public value?: Comision) {}
}

export interface IMenuEvaluador {
  text?: string;
  value?: EvaluadorResumen;
}

export class MenuEvaluador implements IMenuEvaluador {
  constructor(public text?: string, public value?: EvaluadorResumen) {}
}

export interface IRecomendacionValoracion {
  recomienda?: boolean;
  aniosVigencia?: number;
}

export class RecomendacionValoracion implements IRecomendacionValoracion {
  constructor(public recomienda?: boolean, public aniosVigencia?: number) {}
}

/**
 * Registro mostrado en la tabla de solicitudes en asignación de solicitudes
 * Comisión de evaluación
 */
export interface ISolicitudAsignacion {
  solicitudId?: string;
  solucionId?: string;
  clavePrograma?: string;
  nombrePrograma?: string;
  nombreInstitucion?: string;
  cvuCoordinador?: string;
  revision?: IRevision;
  checkedTabla?: boolean;
}

export class SolicitudAsignacion implements ISolicitudAsignacion {
  constructor(
    public solicitudId?: string,
    public solucionId?: string,
    public clavePrograma?: string,
    public nombrePrograma?: string,
    public nombreInstitucion?: string,
    public cvuCoordinador?: string,
    public revision?: IRevision,
    public checkedTabla?: boolean
  ) {
    if (!revision) {
      this.revision = new Revision();
    }
  }

  static fromObject(object: ISolicitudAsignacion): SolicitudAsignacion {
    const transformaciones = {
      revision: (revision: Revision) => (revision != undefined ? Revision.fromObject(revision) : new Revision()),
    };
    const resultado = new SolicitudAsignacion();

    for (const [key, value] of Object.entries(object)) {
      const transform = transformaciones[key as keyof ISolicitudAsignacion];
      resultado[key] = transform ? transform(value) : value;
    }

    return resultado;
  }
}
